<router-outlet></router-outlet>
<!-- <div id="version">{{ appVersion }}</div> -->